<template>
    <aside class="user-menu" :class="{'user-menu--opened': menu_showed}" data-app="true">
        <v-layout class="user-menu__container" row wrap
                  align-center
        >
            <v-flex md12 xs4>
                <router-link :to="{name:'profile'}"><avatar-rounded :image="logged_ava" /></router-link>
            </v-flex>
            <v-flex md12 xs8>
                <v-layout column>
                    <v-flex class="user-menu__name" v-html="logged_name" />
                    <v-flex v-if="user.courses_stat" class="user-menu__stats">
                        <UserStat :number="Number(user.points) || 0" :name="$t('баллы')" :color="'red'" />
                        <UserStat :number="Number(user.courses_stat.completed.stat) || 0" :name="$t('курсы')" :color="'green'" />
                        <!-- <UserStat :number="Number(user.ideas) || 0 " :name="$t('идеи')" /> -->
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout class="user-menu__container" justify-center>
            <linkIcon icon="exit" class="my-3" @click.native="logout">{{ $t("Выход") }}</linkIcon>
        </v-layout>
        <ul class="user-menu__nav">
            <li v-for="(item, i) in accessed_user_menu" :key="i">
                <router-link v-if="!item.children" :to="{name:item.link}" @click.native="HIDE_MENU()">{{ $t(item.text) }}</router-link>
                <v-expansion-panel v-model="subMenu[item.link]" v-if="item.children">
                    <v-expansion-panel-content
                        expand-icon=""
                    >
                        <v-layout slot="header" align-center>
                            <div v-if="item.permission || item.permission.length > 0" class="user-menu__link">
                                <v-layout align-center flex justify-space-between
                                          pr-3
                                >
                                  <router-link
                                      :to="{name: item.link}"
                                      class="user-menu__link-title"
                                      @click.native="HIDE_MENU()"
                                  >
                                    {{ $t(item.text) }}
                                  </router-link>
                                  <div class="user-menu__icon" @click.stop="change_sub_menu(item.link)">
                                    <svg
                                        v-svg
                                        symbol="arrow-right"
                                        size="12"
                                        class="icon user-menu__icon-arrow"
                                        role="presentation"
                                    />
                                  </div>

                                </v-layout>
                            </div>
                        </v-layout>
                        <ul class="user-menu__expansion-list">
                            <li v-for="(itemChildren, itemChildrenIndex) in item.children" :key="itemChildrenIndex">
                                <router-link v-if="itemChildren.permission || itemChildren.permission.length > 0" :to="{name:itemChildren.link}"
                                             @click.native="HIDE_MENU()"
                                >{{ $t(itemChildren.text) }}</router-link>
                            </li>
                        </ul>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </li>
            <template v-if="$vuetify.breakpoint.mdAndDown">
                <li mx-3>
                    <a :class="{'pa-0' : opened==0}">
                        <v-expansion-panel v-model="opened">
                            <v-expansion-panel-content
                                expand-icon=""
                                class="ma-0 pa-0"
                            >
                                <template #header>
                                    <v-layout align-center class="pr-3">
                                        <v-flex class="expansion-header-text">{{ $t("База знаний") }}</v-flex>
                                        <roundButton :icon_name="opened!=null ? 'minus' : 'plus'" :class="{'btn--icon-white': opened!=null}" size="20" />
                                    </v-layout>
                                </template>
                                <ul class="user-menu__nav" @click.native="HIDE_MENU()">
                                    <li v-for="(content,idx) in accessed_database_menu" :key="idx">
                                        <router-link :to="{name: 'database', hash: content.link}">{{ $t(content.text) }}</router-link>
                                    </li>
                                </ul>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </a>
                </li>
                <li v-for="(item, i) in accessed_menu" :key="'k'+i">
                    <router-link :to="{name:item.link}" class="link link--dark link--no-decor" @click.native="HIDE_MENU()">
                        {{ $t(item.text) }}
                    </router-link>
                </li>
            </template>
        </ul>
    </aside>
</template>

<script>
import AvatarRounded from '@/components/blocks/avatar/avatar';
import UserStat from '@/components/blocks/side_menu/user_stat';
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import roundButton from '@/components/ui/buttons/buttons_icon/round_button';
import REGION_CODES from '@/configs/region_codes';
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  components: {
    AvatarRounded,
    UserStat,
    linkIcon,
    roundButton,
  },
  data() {
    return {
      permission_rating: false,
      user_menu        : [],
      database_menu    : [],
      menu             : [],
      opened           : null,
      // expanded-panel у каждого пункта имеею своё состояние
      subMenu          : {
        study: null,
      },
    };
  },
  computed: {
    accessed_user_menu() {
      return this.user_menu.filter((menuItem) => menuItem.permission || menuItem.permission.length > 0);
    },
    accessed_database_menu() {
      return this.database_menu.filter((menuItem) => menuItem.permissions);
    },
    accessed_menu() {
      return this.menu.filter((menuItem) => menuItem.permissions);
    },
    logged_name() {
      return this.user.family + ' '+this.user.name +' '+this.user.patronymic;
    },
    logged_ava() {
      return this.user ? this.user.avatar : '';
    },
    current_route_name() {
      return this.$route.name;
    },
    ...mapGetters('calendar', [
      'menu_showed',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
  },
  async mounted() {
    this.database_menu = [
      {
        text       : this.user.region_code === REGION_CODES.BITUM_MATERIALS ? 'Методические материалы' : 'Международные классификации',
        link       : '#classification',
        permissions: true,
      },
      {
        text       : 'Продуктовый портфель',
        link       : '#product',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text       : 'Одобрения ОЕМ',
        link       : '#oem',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text       : 'Глоссарий',
        link       : '#glossary',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
    ];
    this.menu = [
      {
        text       : 'Новости и мероприятия',
        link       : 'news_main',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      // {
      //   text: 'Банк идей',
      //   link: 'ideas_bank',
      // },
      // {
      //   text: 'Живая лента',
      //   link: 'live_news',
      // },
      {
        text       : 'Вопрос-ответ',
        link       : 'faq',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
      {
        text       : 'Мои заказы',
        link       : 'prize_order',
        permissions: this.user.region_code !== REGION_CODES.BITUM_MATERIALS,
      },
    ];
    this.user_menu = [
      {text: 'Профиль', link: 'profile', permission: this.user.role.my_profile.rights.length || false},
      {text      : 'Обучение', link      : 'study', permission: true, children  : [
        {text: 'Курсы', link: 'study', permission: true},
        // {text: 'Курсы Бизнес+', link: 'study_business_plus', permission: true}, //TODO: раскомментировать на релизе бизнес+
        {text: 'Проверка знаний', link: 'knowledge_check', permission: true},
      ]},
      {text: 'Управление обучением', link: 'training_management', permission: ['ADMINISTRATOR', 'ACADEMY_EMPLOYEE'].includes(this.user.role_code)},
      {text: 'Рейтинг и баллы', link: 'rating', permission: true},
      // {text: this.user.role.my_prizes.rights.length ? 'Мои призы' : 'Магазин призов', link: 'prize_shop', permission: this.user.role.prize_shop.rights.length},
      {text: 'Пользователи и организации', link: 'users', permission: this.user.role.user_analytics.rights.length || false},
      {text: 'Статистика', link: 'employee_study', permission: this.user.role.common_analytics.rights.length || false},
      // {text: 'Активность', link: 'activity', permission: this.user.role.manage_question.rights.length || false},
      // {text: 'Мои мероприятия', link: 'events', permission: this.user.role.manage_events.rights.length || false},
      // {text: 'Правила обучения и обратная связь', link: 'contact', permission: (this.user.role.send_message.rights.length && this.user.region_code !== REGION_CODES.BITUM_MATERIALS) || false},
      {text: 'Правила обучения и обратная связь', link: 'contact', permission: (this.user.role.send_message.rights.length) || false},
      {text: 'Планирование обучения', link: 'study_plan', permission: this.user.access_to_study_plan || false},
    ];

    const currentRoute = this.user_menu.find((item) =>
      item.children &&
          item.children.some((child) => {
            return this.$route.name === child.link;
          })
    );


    if (currentRoute) {
      this.open_sub_menu(currentRoute.link);
    }
  },
  methods: {
    ...mapActions('autorisation', ['logout', 'get_load_user']),
    ...mapMutations('calendar', [
      'TOGGLE_MENU',
      'HIDE_MENU',
    ]),
    ...mapMutations('profile/user', [
      'REPLACE_USER_PROFILE',
    ]),
    open_sub_menu(link) {
      this.$set(this.subMenu, link, 0);
    },
    change_sub_menu(link) {
      this.$set(this.subMenu, link, this.subMenu[link] === 0 ? null : 0);
    },
  },
};
</script>
<style scoped lang="less">
.v-expansion-panel__container {
  cursor: auto;
  .v-expansion-panel__header {
    cursor: auto;
    .user-menu__link {
      padding: 0;
    }
    .user-menu__link-title {
      border: none;
      margin-right: 8px;
    }
    .user-menu__icon {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .user-menu__icon-arrow {
      pointer-events: auto;
    }
  }
}

.v-expansion-panel__container--active {
  .user-menu__link-title {
    color: #fff;
  }
}

.v-expansion-panel__container:not(.v-expansion-panel__container--active) {
  .user-menu__link-title {
    background: transparent;
    color: #4a4a4a;
    border: none;
  }
  .user-menu__link-title:hover {
    color: #e2173d;
  }
}
</style>